export default __webpack_public_path__ + "static/media/welcome-image.85a2cc3b.svg";